<template>
  <tr>
    <td>{{item.client_id}}</td>
    <td>{{item.login}}</td>
    <td>{{item.first_name}} {{item.last_name}}</td>
    <td>{{item.transfer_number}}</td>
    <td>
      <CustomDialog
          :visible="showFromAccDialog"
          @close="showFromAccDialog = false"
          title="Modal Bank Data"
          :confirmBtnText="null"
      >
        <template v-slot:body>
          <div class="row">
            <b>Balance: </b><span>{{item.balance}}</span>
          </div>
        </template>
      </CustomDialog>
      <a @click="showFromAccDialog = true" class="tooltipped" data-position="top" :data-tooltip="balance_statistic">
        {{item.account_special_number}} ({{item.currency_abbreviation}})
      </a>
    </td>
    <td>
      <CustomDialog
          :visible="showToAccDialog"
          @close="showToAccDialog = false"
          title="Modal Bank Data"
          :confirmBtnText="null"
      >
        <template v-slot:body>
          <div class="row">
            <b>Balance: </b><span>{{item.to_account.balance}}</span>
          </div>
        </template>
      </CustomDialog>
      <a class="tooltipped" @click="showToAccDialog = true">{{item.intra_to_account_number}} ({{item.to_account.currency_abbreviation}})</a>
    </td>
    <td>{{item.amount}}</td>
    <td>{{item.reference}}</td>
    <td>{{item.status_name}}</td>
    <td class="action-col">
      <div
        v-if="item.status_name === 'pending'"
        class="accept-button"
        @click="$emit('setTransferStatus', { status: 3, transfer: item.id })"
      >
        <CheckIcon width="12px" height="12px" color="#fff" />
      </div>
      <div v-if="item.status_name === 'pending'" class="close-button" @click="$emit('setTransferStatus', { status: 2, transfer: item.id })">
        <CloseIcon width="12px" height="12px" color="#fff" />
      </div>
    </td>
  </tr>
</template>

<script>
  import CheckIcon from "../icons/Checked"
  import CloseIcon from "../icons/Close"
  import CustomDialog from "../CustomDialog"

  export default {
    name: "IntraTransferRow",
    data: () => ({
      reference: '',
      amount: '',
      showFromAccDialog: false,
      showToAccDialog: false,
    }),

    props: { item: Object },
    computed: {
      balance_statistic: function () {
        return 'balance: ' + this.item.balance + ' / min: ' + this.item.min_balance
      }
    },

    components: {
      CheckIcon,
      CloseIcon,
      CustomDialog,
    },
  }
</script>


<style lang="scss" scoped>

  .action-col {
    display: flex;
  }

  .accept-button,
  .close-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .accept-button {
    background: #26a69a;
    margin-right: 5px;
  }

  .close-button {
    background: #cc3f55;
  }

  .tooltipped {
    cursor: pointer;
  }

  .td-main-btn {
    margin-left: 10px;
  }

  .helper-text {
    color:  #cc3f55;
  }
</style>
